/**
 * Espelha `be/src/modules/scraper/scraper.helpers.ts` — manter em sincronia.
 * Score exibido na lista deve seguir a mesma regra da ordenação “Maior score”.
 */

import { labelTipoImovelApi } from '@/lib/tipo-imovel-label';

export function scoreAuction(
  desconto: number,
  tipoImovel: string
): { score: number; tier: string; risk: string; roiEstimado?: number } {
  let score = 50;
  if (desconto >= 55) score += 35;
  else if (desconto >= 45) score += 25;
  else if (desconto >= 35) score += 15;
  else if (desconto >= 25) score += 8;
  else if (desconto < 10) score -= 15;

  const t = labelTipoImovelApi(tipoImovel).toLowerCase();
  if (t.includes('apartamento') || t.includes('cobertura')) score += 10;
  else if (t.includes('casa')) score += 8;
  else if (t.includes('terreno') || t.includes('lote')) score += 5;
  else if (t.includes('comercial') || t.includes('sala')) score += 2;

  score = Math.max(1, Math.min(100, score));

  const tier = score >= 80 ? 'Excelente' : score >= 60 ? 'Bom' : score >= 40 ? 'Regular' : 'Risco';

  const risk = score >= 75 ? 'Baixo' : score >= 55 ? 'Médio' : score >= 35 ? 'Alto' : 'Crítico';

  const roiEstimado = desconto > 10 ? parseFloat((desconto * 0.55).toFixed(1)) : undefined;

  return { score, tier, risk, roiEstimado };
}

export function effectiveDescontoForScoring(
  desconto: number | null | undefined,
  valorMercado: number | null | undefined,
  lanceMin: number
): number {
  const descontoDb = desconto != null && desconto > 0 ? desconto : null;
  const valorMercadoDb = valorMercado && valorMercado > 0 ? valorMercado : null;
  if (descontoDb != null) return descontoDb;
  if (valorMercadoDb && valorMercadoDb > lanceMin) {
    return Math.round(((valorMercadoDb - lanceMin) / valorMercadoDb) * 100);
  }
  return 0;
}

export function listScoreFromAuctionRow(row: {
  desconto: number | null | undefined;
  valorMercado: number | null | undefined;
  lanceMin: number;
  tipoImovel: string;
}): number {
  const d = effectiveDescontoForScoring(row.desconto, row.valorMercado, row.lanceMin);
  return scoreAuction(d, row.tipoImovel).score;
}
